import { Card } from '@zond/ui';
import { Calendar } from 'lucide-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Empty state component displayed when no attendance data is available
 */
export function ReportAttendanceEmpty() {
  const { t } = useTranslation('reports');
  return (
    <Card className="p-6">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center">
          <span className="text-2xl font-semibold leading-none tracking-tight">{t('attendance.title')}</span>
        </div>
      </div>
      <div className="h-[250px] flex flex-col items-center justify-center text-center">
        <div className="h-12 flex items-center justify-center border rounded-lg p-2 mb-4">
          <Calendar className="h-6 w-6 text-muted-foreground" />
        </div>
        <h3 className="text-xl font-semibold mb-2">{t('attendance.emptyTitle')}</h3>
        <p className="text-muted-foreground">{t('attendance.emptyDescription')}</p>
      </div>
    </Card>
  );
}
